var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoXl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 37,
    viewBox: "0 0 145 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1034_33848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8339 12.2961V28.2221H46.6527V12.2961V11.682H47.2718H52.809V8.80273H36.6602V11.682H42.2148H42.8339V12.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5721 25.3596H78.1119H77.4928V24.7397V20.5743V19.9544H78.1119H85.0494V17.0577H78.1119H77.4928V16.4378V12.2724V11.6525H78.1119H87.5721V8.75H73.6914V28.2447H87.5721V25.3596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.623 19.787L92.8428 8.80273H88.9141L99.1843 27.9962L109.501 8.80273H105.514L99.7166 19.787L99.1669 20.824L98.623 19.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.583 24.7397V20.5743V19.9544H116.202H123.139V17.0577H116.202H115.583V16.4378V12.2724V11.6525H116.202H125.656V8.75H111.781V28.2447H125.656V25.3596H116.202H115.583V24.7397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.171 18.5008L138.414 18.1474L144.923 8.80273H140.641L136.539 14.6772L136.03 15.4014L135.527 14.6772L131.43 8.80273H127.154L133.629 18.1474L133.878 18.5008L133.629 18.8542L127.148 28.2105L131.43 28.2221L135.521 22.3245L136.03 21.5945L136.539 22.3245L140.647 28.2221H144.923L138.414 18.8542L138.171 18.5008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4407 20.766C67.7831 20.3315 68.3674 19.9608 69.1659 19.0396C70.1322 17.9157 70.6009 16.7628 70.6009 15.5115V14.9727C70.6009 12.945 69.8602 11.9601 68.4022 10.7609C66.8515 9.49794 64.6586 8.80273 62.2342 8.80273H54.6719L54.6892 28.2221H58.4907V18.6167H58.4733V11.6762H61.9218C63.3452 11.6762 64.6817 12.0412 65.4166 12.6322H65.4281L65.4339 12.6437C66.2382 13.3389 66.6432 14.1616 66.6432 15.1001C66.6432 17.0467 64.8785 18.6283 62.7145 18.6283H60.4174V18.6167H59.0403L59.5958 19.3177L66.6085 28.2163H71.1968L66.1456 21.7335L65.6017 21.0383L66.4407 20.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8396 24.9425H16.5879V36.4945L33.1649 19.8965C27.6855 19.2128 22.7269 18.9174 18.3468 18.8652L19.8396 24.9367V24.9425Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.1096C3.30383 17.7063 8.34926 18.361 14.928 18.4768L15.009 18.1524C14.0138 17.5962 13.3368 16.5303 13.3368 15.3079C13.3368 13.5119 14.7949 12.052 16.5886 12.052V0.5",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5886 36.5005V24.9485H13.3369L14.8297 18.8887C8.49975 19.0045 3.59897 19.6244 0.3125 20.2038L10.982 24.1259L16.5944 36.5063L16.5886 36.5005Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8396 15.3136C19.8396 16.536 19.1685 17.602 18.1675 18.1582L18.2485 18.4942C22.7385 18.4479 27.836 18.1408 33.4831 17.4224L22.1946 12.8804L16.5879 0.5V12.0578C18.3816 12.0578 19.8396 13.5177 19.8396 15.3136Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4889 17.4224L16.5879 0.5L22.2004 12.8804L33.4889 17.4224Z",
    fill: "url(#paint0_linear_1034_33848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4889 17.4224L16.5879 0.5L22.2004 12.8804L33.4889 17.4224Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9761 24.1194L0.306641 20.1973L16.5886 36.4998L10.9761 24.1194Z",
    fill: "url(#paint1_linear_1034_33848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9761 24.1194L0.306641 20.1973L16.5886 36.4998L10.9761 24.1194Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1034_33848",
    x1: 22.6343,
    y1: 19.0272,
    x2: 25.1399,
    y2: 8.54842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1034_33848",
    x1: 13.0591,
    y1: 19.9192,
    x2: 8.34007,
    y2: 28.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1034_33848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.923,
    height: 36,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXl);
export default __webpack_public_path__ + "static/media/logoXL.a746cc699c82402f98096a941a501664.svg";
export { ForwardRef as ReactComponent };